import React, { useEffect, useState } from 'react'
import ICImage from '../../core-component/ICImage'
import { IAppContent, fetchContentManagementApi } from './AboutUsController'
import { APP_CONTENT_TYPE, DEVICE_TYPES, PUBLIC_HEADER_TABS, PUBLIC_TABS } from '../../utils/AppEnumerations'
import CustomEditor from '../../screens/product-services/Web/CustomEditor'
import UseTranslationHook from '../../hooks/UseTranslationHook'
import { costIcon, customerServiceIcon, expertIcon, healthIcon, rightTickIcon } from '../../assets/icons/SvgIconList'
import { Link } from 'react-router-dom'
import { publicRoute } from '../../routes/RoutePublic'
import CopyrightFooter from '../../components/common/CopyrightFooter'
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import PublicHeader from '../public-header/PublicHeader'
import ICPureImage from '../../core-component/ICPureImage'
import UsePublicDeviceTypeHook from '../../hooks/UsePublicMobileLayoutHook'
import Loader from '../../components/common/Loader'

gsap.registerPlugin(ScrollTrigger);

const AboutUs = () => {
    const [aboutUs, setAboutUs] = useState<IAppContent>();
    const [loading, setLoading] = useState(true);
    const [publicLoader, setPublicLoader] = useState(true);

    useEffect(() => {
        document.title = PUBLIC_TABS.AboutUs;
        fetchContentManagementApi(setAboutUs, APP_CONTENT_TYPE.AboutVp, setLoading);
        setTimeout(async () => {
            setPublicLoader(false)
        }, 2000);
    }, []);
    const { deviceType } = UsePublicDeviceTypeHook();
    useEffect(() => {
        gsap.to(`.text-animation`, {
            yPercent: '120',
            opacity: 1,
            ease: "power4.out",
            duration: 2,
        })
        gsap.to(`.credibility-animation`, {
            scrollTrigger: ".credibility-section",
            xPercent: '27',
            opacity: 1,
            ease: "power4.out",
            duration: 2,
        })
        gsap.to(`.credibility-animation-mobile`, {
            scrollTrigger: ".credibility-section",
            xPercent: '3',
            opacity: 1,
            ease: "power4.out",
            duration: 2,
        })
        gsap.to(`.contact-banner`, {
            scrollTrigger: ".contact-section",
            opacity: 1,
            ease: "power2.out",
            duration: 2,
        })
    })

    const { t } = UseTranslationHook();
    const sentence = t("sentence");
    const speed = 30;
    return (
        <div className='overflow-hidden'>

            {loading || publicLoader ? (<div className="h-screen flex items-center flex-col bg-black">
                <Loader />
            </div>) : (<>
                <div className=' bg-skin-home-bg'>
                    <div className='h-24 relative'> <PublicHeader activeTab={PUBLIC_HEADER_TABS.AboutUs} /></div>
                    <div className='relative h-[250px] '>
                        <div className='flex  justify-center flex-row '>
                            <div className='about-us-head text-animation'>
                                <h1 className='lg:text-7xl text-5xl text-skin-home-text'>{t("get_to_know_us")}</h1>
                            </div>
                        </div>
                    </div>
                    <div className='relative'>
                        <ICPureImage
                            className="absolute top-0 right-0"
                            height={213}
                            width={163}
                            src={require('../../assets/image/Vector-4.png')}
                        />
                        <div className='relative h-[1200px]'>
                            <ICPureImage
                                className="h-full w-full object-cover"
                                src={require('../../assets/image/AboutUsHeroSection.jpg')}
                            />
                            <div className='flex w-full absolute top-[0%] flex-col gap-28 justify-center items-end h-full p-3'>
                                <div className='xl:w-1/2 lg:w-1/2 w-full xl:text-4xl text-2xl pr-4'>
                                    {t("about_us_content")}
                                </div>

                                <div className='xl:w-1/2 lg:w-1/2  w-full text-lg text-skin-title-insights p-3'>
                                    <div className='xl:text-4xl text-3xl  font-bold text-skin-title-insights'>{t("best_of_all_time")}</div>
                                    <div className='grid grid-cols-2 mt-8 text-3xl gap-14'>
                                        <div className='flex items-center'>
                                            <div className='w-7 h-7 mr-3'>{rightTickIcon}</div>
                                            <div>{t("expert_trainer")}</div>
                                        </div>
                                        <div className='flex items-center'>
                                            <div className='w-7 h-7 mr-3'>{rightTickIcon}</div>
                                            <div>{t("expert_trainer")}</div>
                                        </div>
                                        <div className='flex items-center'>
                                            <div className='w-7 h-7 mr-3'>{rightTickIcon}</div>
                                            <div>{t("expert_trainer")}</div>
                                        </div>
                                        <div className='flex items-center'>
                                            <div className='w-7 h-7 mr-3'>{rightTickIcon}</div>
                                            <div>{t("expert_trainer")}</div>
                                        </div>
                                        <div className='flex items-center'>
                                            <div className='w-7 h-7 mr-3'>{rightTickIcon}</div>
                                            <div>{t("expert_trainer")}</div>
                                        </div>
                                        <div className='flex items-center'>
                                            <div className='w-7 h-7 mr-3'>{rightTickIcon}</div>
                                            <div>{t("expert_trainer")}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ICPureImage
                                className="absolute bottom-[-2%] left-0"
                                height={213}
                                width={163}
                                src={require('../../assets/image/Vector-5.png')}
                            />
                        </div>
                    </div>
                    <section className={`top relative xl:h-[500px] credibility-section overflow-hidden`}>
                        <div className={`xl:w-2/3 ${deviceType === DEVICE_TYPES.Mobile || deviceType === DEVICE_TYPES.Tablet || deviceType === DEVICE_TYPES.Laptop ? "credibility-animation-mobile" : "credibility-animation"} translate-x-[-50%]`}>
                            <h1 className='text-skin-home-text text-center text-5xl'>{t("why_vprosper")}</h1>
                            <div className="top grid xl:grid-cols-2 grid-cols-1 rounded-lg p-3 text-skin-home-text">
                                <div>
                                    <div className='flex xl:flex-row flex-col justify-center w-full items-center'>
                                        <div className='xl:w-[20%] w-[20%] mr-3 mt-4'>
                                            {expertIcon}
                                        </div>
                                        <div className='xl:w-[60%] w-full p-3'>
                                            <h1 className='text-2xl'>{t("expertise")}</h1>
                                            <h1 className='leading-7 mt-2'>
                                                {t("expert_sentence")}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className='flex xl:flex-row flex-col justify-center w-full items-center'>
                                        <div className='xl:w-[20%] w-[20%] mr-3'>
                                            {customerServiceIcon}
                                        </div>
                                        <div className='xl:w-[60%] p-3'>
                                            <h1 className='text-2xl'>{t("customer_support")}</h1>
                                            <h1 className='leading-7 mt-2'>
                                                {t("customer_support_sentence")}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className='flex xl:flex-row flex-col justify-center w-full items-center'>
                                        <div className='xl:w-[20%] w-[20%] mr-3'>
                                            {costIcon}
                                        </div>
                                        <div className='xl:w-[60%] w-full p-3'>
                                            <h1 className='text-2xl'>{t("cost_effective")}</h1>
                                            <h1 className='leading-7 mt-2'>
                                                {t("cost_effective_sentence")}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className='flex xl:flex-row flex-col justify-center w-full items-center'>
                                        <div className='xl:w-[20%] w-[20%] mr-3'>
                                            {healthIcon}
                                        </div>
                                        <div className='xl:w-[60%] p-3'>
                                            <h1 className='text-2xl'>{t("healthy_life")}</h1>
                                            <h1 className='leading-7 mt-2'>
                                                {t("healthy_life_sentence")}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div>
                        <div className='relative h-[1370px]'>
                            <ICPureImage
                                className="h-full w-full object-cover"
                                src={require('../../assets/image/Frame 24-2.jpg')}
                            />
                            <ICPureImage
                                className="absolute lg:top-[30%] top-[10%]  right-0"
                                height={213}
                                width={163}
                                src={require('../../assets/image/Vector-6.png')}
                            />
                            <div className='flex w-full absolute top-[3%] justify-start items-center h-full p-3'>
                                <div className='xl:w-1/2 lg:w-1/2 w-full xl:text-4xl xl:mt-5 mt-20 xl:ml-20 lg:ml-20 text-skin-title-insights text-2xl'>
                                    {t("our_mission")}
                                </div>
                            </div>
                            <ICPureImage
                                className="absolute lg:top-[30%] top-[10%] left-0"
                                height={213}
                                width={163}
                                src={require('../../assets/image/Group 105.png')}
                            />

                        </div>
                    </div>
                    {aboutUs && <div className=' bg-skin-about-banner flex justify-center'>
                        <div className='lg:w-2/3 w-4/5 top mb-10 p-4 rounded-lg'>
                            <div className='text-skin-home-text'><CustomEditor serviceDesc={aboutUs?.value} containerClassName='!text-skin-home-text !text-xl' /></div>
                        </div>
                    </div>}
                    <div className='flex justify-end contact-section quote-bg'>
                        <div className='xl:w-2/3 h-[20rem] p-4 flex xl:flex-row flex-col xl:items-center justify-center text-skin-home-text'>
                            <div className='w-[70%] text-4xl contact-banner opacity-0'>
                                <div><h1>{t("looking_for_solution")}</h1></div>
                                <div className='text-xl top'>{t("we_are_here")}</div>
                            </div>
                            <div className='contact-banner opacity-0 xl:block flex justify-end mt-5 mb-5'>
                                <p className=''>
                                    <Link to={`/${publicRoute.contactUs}`} className='text-right bg-skin-home-bg p-5 text-3xl rounded-xl'> {t("contact_us")} </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div><CopyrightFooter /></div>
                </div></>)}
        </div>
    )
}

export default AboutUs